export default {
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 30,
  },
};
